import { render, staticRenderFns } from "./userTableDataView.vue?vue&type=template&id=fad3b154&scoped=true"
import script from "./userTableDataView.vue?vue&type=script&lang=js"
export * from "./userTableDataView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad3b154",
  null
  
)

export default component.exports